import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Stack } from '@mui/material'

import chatHook from '@hooks/useChat'
import titleHook from '@hooks/useTitle'

import { AsSeenInSection } from '@pages/LandingPage/Home/components/AsSeenInSection'
import { ContentSection } from '@pages/LandingPage/Home/components/ContentSection'
import { HeroSection } from '@pages/LandingPage/Home/components/HeroSection'
import { OurItCustomersSection } from '@pages/LandingPage/Home/components/OurItCustomersSection'
import { LatestBlogPosts } from '@pages/LandingPage/components/LatestBlogPosts'

import { ContactUs } from '@components/ContactUs'
import { LeadMagnet } from '@components/LeadMagnet'
import { MatchesCountSection } from '@components/MatchesCountSection'

const Home = () => {
  const { setIsShowAssistanceChatBubble } = chatHook.useChat()

  const { t } = useTranslation()

  titleHook.useTitle(t('Technology Match'))

  useEffect(() => {
    setIsShowAssistanceChatBubble(true)
  }, [setIsShowAssistanceChatBubble])

  return (
    <Stack>
      <HeroSection />
      <MatchesCountSection />
      <LeadMagnet />
      <OurItCustomersSection />
      <ContentSection />
      <AsSeenInSection />
      <LatestBlogPosts />
      <ContactUs />
    </Stack>
  )
}

export { Home }
